/**
 * Dev-only logger.
 *
 * `console.warn` / `console.error` calls are useful while developing, but in a
 * production bundle they pollute the user's devtools and leak internal context.
 * In `NODE_ENV === "production"` this module no-ops.
 *
 * Use `logger.warn(...)` everywhere instead of `console.warn`.
 */

const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

export const logger = {
    warn: isProd ? noop : (...args) => console.warn(...args),
    error: isProd ? noop : (...args) => console.error(...args),
    info: isProd ? noop : (...args) => console.info(...args),
};
